import React from "react";
import PropTypes from "prop-types";
import { Datepicker } from "components/common/datepicker";
import { Button } from "components/common/button";
import { getThisFinancialYear, getLastFinancialYear } from "utils/financial-year";
import { momentType } from "custom-prop-types";
import styles from "components/common/date-range.scss";

export const DateRange = ({
  currency,
  endDate,
  onAddEndDate,
  onAddStartDate,
  startDate
}) => (
  <div className={ styles.container }>
    <div className={ styles["start-date-container"] }>
      { renderDatepicker(currency, endDate, onAddEndDate, onAddStartDate, "Start date", true, startDate) }
    </div>
    <div className={ styles["end-date-container"] }>
      { renderDatepicker(currency, endDate, onAddEndDate, onAddStartDate, "End date", false, startDate) }
    </div>
  </div>
);

DateRange.propTypes = {
  currency: PropTypes.string.isRequired,
  endDate: momentType,
  onAddEndDate: PropTypes.func.isRequired, // (data: dataType) => void
  onAddStartDate: PropTypes.func.isRequired,
  startDate: momentType
};

DateRange.defaultProps = {
  endDate: null,
  startDate: null
};

const renderDatepicker = (
  currency,
  endDate,
  onAddEndDate,
  onAddStartDate,
  placeholder,
  isStart,
  startDate
) => (
  <Datepicker
    endDate={ endDate }
    isClearable
    onDateSelected={ isStart ? onAddStartDate : onAddEndDate }
    placeholderText={ placeholder }
    selected={ isStart ? startDate : endDate }
    selectsEnd={ isStart }
    selectsStart={ isStart }
    startDate={ startDate }
  >
    <SelectFinancialYear currency={ currency } onAddEndDate={ onAddEndDate } onAddStartDate={ onAddStartDate } />
  </Datepicker>
);

const SelectFinancialYear = ({ currency, onAddEndDate, onAddStartDate }) => (
  <div className={ styles["financial-year"] }>
    <Button link onClick={ () => getFinancialYearRange(onAddEndDate, onAddStartDate, true, currency) }>
      Last financial year
    </Button>
    <Button link onClick={ () => getFinancialYearRange(onAddEndDate, onAddStartDate, false, currency) }>
      This financial year
    </Button>
  </div>
);

SelectFinancialYear.propTypes = {
  currency: PropTypes.string.isRequired,
  onAddEndDate: PropTypes.func.isRequired, // (data: dataType) => void
  onAddStartDate: PropTypes.func.isRequired
};

const getFinancialYearRange = (onAddEndDate, onAddStartDate, isLast, currency) => {
  const { startDate, endDate } = isLast ? getLastFinancialYear(currency) : getThisFinancialYear(currency);
  onAddStartDate(startDate);
  onAddEndDate(endDate);
};



// WEBPACK FOOTER //
// ./src/js/components/common/date-range.jsx